import React, { useEffect, useState } from 'react';
import { Container, Grow, Grid, Paper } from '@material-ui/core';

import MultiSpeciesPagination from './MultiSpeciesPagination';
import { MultiSpecies } from "./MultiSpecies";
import { useDispatch } from 'react-redux';

import { Link, useLocation } from 'react-router-dom';

import { getMultiSpecies } from '../../actions/species';
import { buildThemeHref, getDiscoveryTheme, readDiscoveryTheme } from '../../lib/discoveryThemes';
import { ThemeSwitch } from '../Theme/ThemeSwitch';

import SearchBar from "material-ui-search-bar";
// import {SpeciesData} from 'SpeciesData.json';
// For autocomplete: https://teamwertarbyte.github.io/material-ui-search-bar/

function useQuery() {
    return new URLSearchParams(useLocation().search)
}

export const MultiSpeciesPage = (props) => {
    const location = useLocation();
    const query = useQuery();
    const page = query.get('page') || 1;
    const querySearch = query.get('q') || '';
    const activeTheme = readDiscoveryTheme(location.search);
    const themeConfig = getDiscoveryTheme(activeTheme);
    const [searchQuery, setSearchQuery] = useState(querySearch);

    const dispatch = useDispatch();

    useEffect(() => {
        setSearchQuery(querySearch);
        if (activeTheme === 'wildlife') {
            dispatch(getMultiSpecies(page, querySearch));
        }
    }, [activeTheme, page, querySearch, dispatch]);

    return (
        <Grow in id="species_page">
            <Container className="atlas-route-shell">
                <div className="atlas-page-header">
                    <span className="atlas-eyebrow">{activeTheme === 'wildlife' ? 'Species atlas' : themeConfig.label}</span>
                    <h1>{themeConfig.catalog.title}</h1>
                    <p>{themeConfig.catalog.description}</p>
                </div>
                <ThemeSwitch className="atlas-theme-switch--page" overrides={{ page: 1, q: null }} />
                <Grid container justifyContent="space-between" alignItems="stretch" spacing={3}>
                    {activeTheme === 'wildlife' ? (
                        <>
                            <Grid item xs={12}>
                                <div className="atlas-search-shell">
                                    <SearchBar id="search" 
                                    value={searchQuery}
                                    onChange={(newValue) => setSearchQuery(newValue)}
                                    placeholder="Enter a species e.g. Mola mola"
                                    onRequestSearch={() => dispatch(getMultiSpecies(page, searchQuery))}
                                />
                                </div>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <MultiSpecies />
                            </Grid>
                        </>
                    ) : (
                        <Grid item xs={12} md={8}>
                            <div className="atlas-catalog-grid">
                                {themeConfig.catalog.cards.map((card) => (
                                    <article key={card.title} className="atlas-catalog-card">
                                        <span className="atlas-card-kicker">{card.subtitle}</span>
                                        <h3>{card.title}</h3>
                                        <p>{card.summary}</p>
                                    </article>
                                ))}
                            </div>
                            <Paper elevation={6} className="atlas-sidebar-card atlas-theme-story-card">
                                <div className="atlas-sidebar-copy atlas-sidebar-copy--flush">
                                    <h3>Use this atlas as background, then plan from it.</h3>
                                    <p>
                                        These cards are here to give you the core subjects for this mode in one place.
                                        Use the planner when you want to test a location, date, and radius against them.
                                    </p>
                                    <div className="atlas-cta-row">
                                        <Link
                                            className="atlas-primary-link"
                                            to={buildThemeHref('/planner', location.search, activeTheme)}
                                        >
                                            Open {themeConfig.nav.planner.toLowerCase()}
                                        </Link>
                                    </div>
                                </div>
                            </Paper>
                        </Grid>
                    )}
                    <Grid item xs={12} md={4}>
                        <Paper elevation={6} className="atlas-sidebar-card">
                            <div className="atlas-sidebar-copy">
                                <h3>{themeConfig.catalog.sidebarTitle}</h3>
                                <p>{themeConfig.catalog.sidebarCopy}</p>
                            </div>
                            {activeTheme === 'wildlife' ? <MultiSpeciesPagination page={page} /> : null}
                        </Paper>
                    </Grid>
                </Grid>
            </Container>
        </Grow>
    )
}
